<template>
  <div>
    <div class="chart" style="height: 500px; padding-right: 30px;"/>
  </div>
</template>

<script>
  export default {
    name: "Demo",
    data() {
      return {
        total: [50, 50, 50, 50, 50],
        finished: [11, 0, 1, 49, 50],
        unfinished: [39, 50, 49, 1, 0],
        max: 60,
      };
    },
    mounted() {
      this.$nextTick(() => {
        this.initChart();
      });
    },
    methods:{
      initChart() {
        let myChart = this.$echarts.init(document.querySelector(".chart"));
        let  option = {
          title: {
            text: "控制柜生产看板",
            left:"20px",
            textStyle: {
              color: "#436EEE",
              fontSize: 20,
            },
          },
          tooltip : {
            trigger: "axis",
            axisPointer : {
              type : "shadow",
            },
          },
          grid: {
            left: "3%",
            right: "6%",
            top: "20%",
            bottom: "1%",
            containLabel: true,
          },
          legend: {
            itemWidth:15,
            itemHeight:15,
            data:["已完成","未完成"],
          },
          xAxis : [
            {
              type : "category",
              name : "流水线",
              nameTextStyle:{
                color : "red",
                fontSize : 16,
              },
              data : ["1","2","3","4","5"],
              axisTick: {
                alignWithLabel: true,
              },
            },
          ],
          yAxis : [
            {
              type : "value",
              name : "数量",
              nameTextStyle:{
                color : "red",
                fontSize : 16,
              },
              max: this.max,
            },
          ],
          series: [{
                     name: "已完成",
                     type: "bar",
                     stack:"任务",
                     barWidth: "40%",
                     data: this.finished,
                     itemStyle:{
                       normal:{
                         color:"#FF8849",
                         label: {
                           show: true,
                           position: "insideTop",
                         },
                       },
                     },
                   },
                   {
                     name: "未完成",
                     type: "bar",
                     stack:"任务",
                     data: this.unfinished,
                     itemStyle:{
                       normal:{
                         color:"#3FBB49",
                         label: {
                           show: false,
                           position: "top",
                         },
                       },
                     },
                   },
                   {
                     name: "总计",
                     type: "bar",
                     stack: "任务",
                     label: {
                       normal: {
                         offset:["50", "80"],
                         show: true,
                         position: "insideBottom",
                         formatter:"{c}",
                         textStyle:{
                           color:"#3FBB49",
                         },
                       },
                     },
                     itemStyle:{
                       normal:{
                         color:"rgba(128, 128, 128, 0)",
                       },
                     },
                     data: this.total,
                   },
          ],
        };
        myChart.setOption(option);
      },
    },
  };
</script>